<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-bank"></i>
          </div>
          <div>
            <h1 class="banner-title">DANH SÁCH NGÂN HÀNG HỖ TRỢ THANH TOÁN</h1>
            <p class="banner-subtitle">Xem danh sách các đối tác ngân hàng được hỗ trợ liên kết và thanh toán trực tuyến qua cổng SePay.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-folder-opened"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng đối tác ngân hàng</p>
          <h3 class="stat-value">{{ dataTable.length }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đang hỗ trợ kết nối</p>
          <h3 class="stat-value">{{ stats.activeCount }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-circle-close"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đã cấu hình</p>
          <h3 class="stat-value">SePay Gateway</h3>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        ref="multipleTable"
        :data="dataTable"
        v-loading="loading.table"
        element-loading-text="Đang tải danh sách ngân hàng..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        :max-height="tableMaxHeight"
      >
        <el-table-column type="index" label="STT" width="60" align="center" />

        <el-table-column label="Logo" width="140" align="center">
          <template slot-scope="{ row }">
            <div class="bank-logo-wrapper">
              <el-image
                :src="row.logo"
                fit="contain"
                class="bank-logo"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Tên ngân hàng đối tác" min-width="250" prop="name">
          <template slot-scope="{ row }">
            <span class="bank-name">{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tên thương hiệu" min-width="180" align="center" prop="shortName">
          <template slot-scope="{ row }">
            <span class="short-name-badge">{{ row.shortName || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tên viết tắt" min-width="180" align="center" prop="short_name">
          <template slot-scope="{ row }">
            <span class="short-name-badge secondary">{{ row.short_name || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái hệ thống" width="200" align="center" prop="delActive">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="row.delActive ? 'online' : 'offline'">
              <span class="dot"></span>
              {{ row.delActive ? 'Hỗ trợ kết nối' : 'Ngừng hỗ trợ' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import sePayConnectionService from "@/services/SePayConnectionService";

export default {
  name: "BanksConnectedSePay",
  data() {
    return {
      dataTable: [],
      loading: {
        table: false
      }
    };
  },
  
  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 750;
    },
    
    stats() {
      let activeCount = 0;
      this.dataTable.forEach(x => {
        if (x.delActive) activeCount++;
      });
      return { activeCount };
    }
  },

  created() {
    this.findAllData();
  },

  methods: {
    async findAllData() {
      this.loading.table = true;
      try {
        const response = await sePayConnectionService.getSePayConnectionServiceSupport();
        if (response.data.status === 200) {
          this.dataTable = response.data.data.data || [];
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.table = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }
}

/* Custom Table Components */
.bank-logo-wrapper {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  border-radius: 8px;
  display: inline-block;
  
  .bank-logo {
    max-width: 90px;
    height: 36px;
    display: block;
  }

  .image-slot {
    font-size: 20px;
    color: #94a3b8;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.bank-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.short-name-badge {
  font-weight: 700;
  font-size: 13px;
  background-color: #eff6ff;
  color: #1d4ed8;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #dbeafe;

  &.secondary {
    background-color: #f8fafc;
    color: #64748b;
    border-color: #e2e8f0;
  }
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 9999px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.online {
    background-color: #f0fdf4;
    color: #166534;
    .dot {
      background-color: #22c55e;
      box-shadow: 0 0 8px #22c55e;
      animation: pulseGreen 2s infinite;
    }
  }

  &.offline {
    background-color: #fef2f2;
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

@keyframes pulseGreen {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
</style>